export default __webpack_public_path__ + "static/media/settings.d9d08c20.svg";